/* ============================================================
   c_grid-paginate.js — クライアント側ページネーション
   [data-cpage-grid] 内の商品カードを data-cpage-per 件ずつに分割して表示する。
   タブ（タグ絞り込み）ごとに独立したグリッドに適用されるため、
   「絞り込んだ結果に対してページ送り」が正しく機能する。
   ページUI は c_pagination.css のクラスを再利用する。
   ============================================================ */
(function () {
  if (window.__cGridPaginate) return;
  window.__cGridPaginate = true;

  var ARROW =
    '<path d="M12 0.752577L20 7.75258L12 14.7526" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>' +
    '<path d="M0 7.75258L20 7.75258" stroke="currentColor" stroke-width="2"/>';
  function arrowSvg(prev) {
    return (
      '<svg class="c-pagination__arrow' + (prev ? ' c-pagination__arrow--prev' : '') +
      '" width="16" height="12" viewBox="0 0 21 15.5052" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
      ARROW + '</svg>'
    );
  }

  /* sticky ヘッダー分を差し引いてセクション先頭にスクロール */
  function scrollToAnchor(id) {
    var el = id && document.getElementById(id);
    if (!el) return;
    var header = document.querySelector('.c-header-wrap');
    var offset = header ? header.getBoundingClientRect().height : 0;
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset - 10;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  function makeItem(inner, label, opts) {
    var li = document.createElement('li');
    li.className = 'c-pagination__item';
    var el;
    if (opts.current) {
      el = document.createElement('span');
      el.className = 'c-pagination__link is-current';
      el.setAttribute('aria-current', 'page');
    } else {
      el = document.createElement('button');
      el.type = 'button';
      el.className = 'c-pagination__link' + (opts.arrow ? ' c-pagination__link--arrow' : '');
      el.setAttribute('data-cpage-goto', opts.goto);
    }
    if (label) el.setAttribute('aria-label', label);
    el.innerHTML = inner;
    li.appendChild(el);
    return li;
  }

  function renderNav(nav, page, total) {
    var ul = document.createElement('ul');
    ul.className = 'c-pagination__list';
    /* 読み上げ名は Liquid が翻訳キーから data-label-* に入れる（無ければ英語） */
    var lPrev = nav.getAttribute('data-label-prev') || 'Previous page';
    var lNext = nav.getAttribute('data-label-next') || 'Next page';
    var lPage = nav.getAttribute('data-label-page') || 'Page [n]';
    if (page > 1) ul.appendChild(makeItem(arrowSvg(true), lPrev, { arrow: true, goto: page - 1 }));
    for (var n = 1; n <= total; n++) {
      ul.appendChild(makeItem(String(n), lPage.replace('[n]', String(n)), n === page ? { current: true } : { goto: n }));
    }
    if (page < total) ul.appendChild(makeItem(arrowSvg(false), lNext, { arrow: true, goto: page + 1 }));
    nav.innerHTML = '';
    nav.appendChild(ul);
  }

  function initGrid(grid) {
    if (grid.dataset.cpageInit) return;
    grid.dataset.cpageInit = '1';

    var per = parseInt(grid.getAttribute('data-cpage-per'), 10) || 12;
    var anchor = grid.getAttribute('data-cpage-anchor');
    var nav = grid.parentElement ? grid.parentElement.querySelector('[data-cpage-nav]') : null;
    var cards = Array.prototype.filter.call(grid.children, function (el) {
      return el.classList && el.classList.contains('c-pcard');
    });
    var total = Math.ceil(cards.length / per);

    if (total <= 1) { if (nav) nav.innerHTML = ''; return; }

    function show(page, doScroll) {
      if (page < 1) page = 1;
      if (page > total) page = total;
      var start = (page - 1) * per;
      var end = start + per;
      for (var i = 0; i < cards.length; i++) {
        if (i >= start && i < end) cards[i].removeAttribute('hidden');
        else cards[i].setAttribute('hidden', '');
      }
      if (nav) renderNav(nav, page, total);
      grid.dataset.cpageCurrent = page;
      if (doScroll) scrollToAnchor(anchor);
    }

    if (nav) {
      nav.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('[data-cpage-goto]') : null;
        if (!btn) return;
        e.preventDefault();
        show(parseInt(btn.getAttribute('data-cpage-goto'), 10), true);
      });
    }

    show(1, false);
  }

  function init() {
    var grids = document.querySelectorAll('[data-cpage-grid]');
    for (var i = 0; i < grids.length; i++) initGrid(grids[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
